// @ts-nocheck
// TODO: tighten types after migration
import React, { useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { generateBreadcrumbStructuredData } from '../utils/structuredData';
import './Breadcrumbs.css';

const Breadcrumbs = ({ hideLastItem = false }) => {
  const location = useLocation();
  let pathnames = location.pathname.split('/').filter(x => x);
  
  // Special case for Blog Post pages: Remove the slug from breadcrumbs
  // Check if we are on a blog post page (e.g. /blog/post-slug or /category/post-slug)
  // Logic: if 'blog' is in path and not the last item, OR if 'category' is in path, we might need adjustments.
  // Current requirement: Remove slug from Breadcrumbs in Post page.
  // Assuming Post page structure is /blog/:slug or /:category/:slug
  
  // New requirement: Remove episode title from Podcast Breadcrumbs
  if (pathnames[0] === 'podcast' && pathnames.length > 1) {
    pathnames = ['podcast'];
  } 
  // Existing logic for blog post pages (refining for consistency based on previous tasks)
  else if (hideLastItem && pathnames.length > 0) {
    pathnames = pathnames.slice(0, -1);
  }

  const getBreadcrumbName = (pathname) => {
    const nameMap = {
      'blog': 'Blog',
      'store': 'Store',
      'podcast': 'Podcast',
      'e-products': 'E-Products',
      'cart': 'Cart',
      'contact': 'Contact',
      'signin': 'Sign In',
      'edit-profile': 'Edit Profile',
      'order-history': 'Order History'
    };
    // Decode URL components and replace %20 with space, then apply name mapping or capitalize
    const decodedPathname = decodeURIComponent(pathname);
    return nameMap[decodedPathname] || decodedPathname.charAt(0).toUpperCase() + decodedPathname.slice(1);
  };

  useEffect(() => {
    if (pathnames.length > 0) {
      const structuredData = generateBreadcrumbStructuredData(pathnames);
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(structuredData);
      document.head.appendChild(script);
      
      return () => {
        document.head.removeChild(script);
      };
    }
  }, [pathnames]);

  if (pathnames.length === 0) return null;

  return (
    <nav className="breadcrumbs max-w-[2000px] py-[10px] bg-[var(--bg-color)] border-b border-[var(--slider-color)]" aria-label="Breadcrumb">
      <ol className="breadcrumb-list flex items-center list-none m-0 px-[10px] flex-wrap gap-2 max-w-6xl mx-0 ml-[3%] justify-start">
        <li className="breadcrumb-item flex items-center text-[0.9em]">
          <Link to="/" className="breadcrumb-link text-[#47b5ff] no-underline flex items-center gap-1 transition-colors duration-200 hover:text-[#3a9bdb] hover:underline">
            Home
          </Link>
        </li>
        {pathnames.map((name, index) => {
          const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
          // Correct check for active page: exact match with current location
          const isLast = routeTo === location.pathname;

          return (
            <li key={name} className="breadcrumb-item flex items-center text-[0.9em]">
              <span className="breadcrumb-separator text-[var(--slider-color)] mx-1 font-medium">/</span>
              {isLast ? (
                <span className="breadcrumb-current text-[var(--post-content-font)] font-medium" aria-current="page">
                  {getBreadcrumbName(name)}
                </span>
              ) : (
                <Link to={routeTo} className="breadcrumb-link text-[#47b5ff] no-underline flex items-center gap-1 transition-colors duration-200 hover:text-[#3a9bdb] hover:underline">
                  {getBreadcrumbName(name)}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
